var ko = require('knockout');
var ContentLibraryCategoryViewModel = require('./content-library-category.vm.js');
var ContentLibraryCartViewModel = require('./content-library-cart.vm.js');
var Modernizr = require('../../vendors/modernizr.min');
var WS = require("../../scripts/ws");

var desktopMq = '(min-width: 992px)',
    tabletMq = '(min-width: 768px)';

var parameterName = "";

function ContentLibraryViewModel(contentLibrary, orderPageUrl) {
    var self = this;

    let defaultCategory = null;
    self.cart = ko.observable(new ContentLibraryCartViewModel());
    self.categories = ko.observableArray([]);
    self.orderPageUrl = ko.observable(orderPageUrl);
    self.isNotMobile = ko.observable(new Boolean);
    self.openCategory = ko.observable(new Boolean);

    self.updateCart = function () {
        var items = self.getItemsInCart();
        self.cart().items(items);
    };

    self.getItemsInCart = function () {
        var cart = [];

        for (var catIndex = 0; catIndex < self.categories().length; catIndex++) {
            var cat = self.categories()[catIndex];

            for (var subIndex = 0; subIndex < cat.subcategories().length; subIndex++) {
                var sub = cat.subcategories()[subIndex];

                for (var itemIndex = 0; itemIndex < sub.items().length; itemIndex++) {
                    var item = sub.items()[itemIndex];
                    if (item.quantity() > 0) {
                        item.parentName(sub.name());
                        cart.push(item);
                    }
                }
            }
        }

        return cart;
    };

    self.isNotMobile = function () {
        if (Modernizr.mq(desktopMq) || Modernizr.mq(tabletMq)) {
            return true;
        }
        return false;
    };

    self.isDefaultCategory = function (index, category) {
        if (category.isDefaultCategory()) {
            var top = $('#category_' + index + '_' + $.escapeSelector(category.name().replace(/\s+/g, ''))).position().top;
            $(window).scrollTop(top);
            return true;
        } else if (!defaultCategory && parseInt(index) === 0 && self.isNotMobile()) {
            return true;
        }

        return false;
    };

    self.reviewOrderedItems = function () {
        if (self.getItemsInCart().length !== 0) {
            sessionStorage.contentLibraryModel = ko.toJSON(self);

            window.location.href = orderPageUrl;
        }
    };

    if (sessionStorage.contentLibraryModel) {
        var parsed = JSON.parse(sessionStorage.contentLibraryModel);
        contentLibrary = parsed.categories;
    }

    if (contentLibrary) {
        let categories = [];
        contentLibrary.forEach(function (category) {
            let categoryVm = new ContentLibraryCategoryViewModel(category);
            categoryVm.loadItems();
            categories.push(categoryVm);
        });
        self.categories(categories);

        self.updateCart();

        if (categories.length) {
            var qsCategory = WS.queryString["category"];

            if (qsCategory && qsCategory.length > 0) {
                for (let i = 0; i < categories.length; i++) {
                    if (categories[i].name() === qsCategory) {
                        defaultCategory = categories[i];
                        defaultCategory.isDefaultCategory(true);
                        break;
                    }
                }
            }

            if (defaultCategory) {
                defaultCategory.loadSubcategoryItems();
            } else {
                categories[0].loadSubcategoryItems();
            }
        }
    }
}

module.exports = ContentLibraryViewModel;